'use strict';

const callWebService = require('./serverActions/callWebService');
var capAddressConfig = [];
var urlCapEmailConfig = $("#url-cap-email-config").val();

/// Call Ajax for get All configuration 

$.ajax({
    url: urlCapEmailConfig,
    type: 'get',
    async: false,
    dataType: 'json',
    success: function (data) {
        var capConfiguration = data.result;
        capAddressConfig = capConfiguration.length > 0 ? JSON.parse(capConfiguration) : [];
    },
    error: function (err) { }
});

/**
 * @function getConfig return all the form id
 * @param {idForm}
*/

function getConfig(idForm, editableT) {
    if (capAddressConfig.length > 0) {
        var form = {};
        var currentForms = capAddressConfig.filter(form => form.idForm === idForm);
        var formEdit = capAddressConfig.find(form => form.idForm === idForm);

        if (currentForms.length === 2) {
            form = currentForms.find(form => form.idForm === idForm && form.hasOwnProperty("editable") && form.editable === editableT);
            return form;
        }
        return formEdit;
    }
}

/**
 * @function getIdForms return all the form id
*/
function getIdForms() {
    var ids = [];
    capAddressConfig.forEach(obj => {
        ids.push(obj.idForm);
    });
    return ids;
}

/**
 * @function dataSourceEmail Resulat ajax for get suggestions
 * @param {configCurrentForm}
*/

function dataSourceEmail(configCurrentForm) {

    var $emailSelector = $("#" + configCurrentForm.EmailID);
    var $formID = $("#" + configCurrentForm.idForm);
    var $firstNameSelector = $("#" + configCurrentForm.firstName);
    var $lastNameSelector = $("#" + configCurrentForm.lastName);

    var email = $emailSelector.val();
    var fname = $firstNameSelector.val();
    var lname = $lastNameSelector.val();

    var searchResulat = callWebService.SearchMailCivWS(email, fname, lname);

    if (searchResulat.returnCode && searchResulat.returnCode === 1) {
        $emailSelector.next('.invalid-feedback').empty().html(searchResulat.sMessage).show();
        $emailSelector.addClass("is-invalid");
        $formID.find(":submit").prop('disabled', true);

    } else {
        $emailSelector.next('.invalid-feedback').hide();
        $emailSelector.removeClass("is-invalid");
        $formID.find(":submit").prop('disabled', false);
        var finalDatasource = null;
        var finalDatasource = $.map(searchResulat.mail, function (item) {
            return {
                label: item.sMail,
                value: item.sMail,
            }
        });
        $emailSelector.autocomplete({
            create: function (event, ui) {
                $(this).attr('autocomplete', 'nope');
            },
            minLength: 0,
            autoFocus: true,
            source: function (request, response) {
                var items = [];

                $.each(finalDatasource, function (key, val) {
                    items.push(val);
                });

                response(items);

            },
            select: function (event, ui) {
                $(this).next().html(ui.item.sMail);
            }

        }).focus(function (e) {
            return false;
        });

    }
}


/**
 * @function callProcessAddressFlow Enable UI-autocomplete form zipID
 * @param {configCurrentForm}
*/

function callProcessEmailFlow(currentFormConfig, value) {
    if (currentFormConfig.hasOwnProperty("EmailID")) {
        dataSourceEmail(currentFormConfig);
    }
}

module.exports = {
    getConfig: getConfig,
    getIdForms: getIdForms,
    callProcessEmailFlow: callProcessEmailFlow
}